@if(!isFetching) {
    @if (!breakpointService.isMobile()) {
        <div class="trip-card">
            <div class="trip-card__header">
                <h3 class="trip-name">{{ trip.name }}</h3>
                <ul class="user-actions">
                    <li class="user-actions__item user-actions__item--date">
                      Modified: {{trip?.itineraries_date | date: 'MMM d, y'}}
                    </li>
                    <div class="user-actions__divider"></div>
                    <li class="user-actions__item" (click)="shareTrip.next(trip)">
                        <img src="assets/svg/ic-export.svg" alt="export">
                    </li>
                    <div class="user-actions__divider"></div>
                    <li class="user-actions__item" (click)="onPrintTripOverviewHandler()">
                        <img src="assets/svg/ic-print-w.svg" alt="print">
                    </li>
                    <div class="user-actions__divider"></div>
                    <li class="user-actions__item" (click)="remove.next(trip)">
                        <img src="assets/svg/ic-delete.svg" alt="delete">
                    </li>
                    <div class="user-actions__divider"></div>
                </ul>
            </div>
            <div class="trip-card__body">
                <div class="trip-card__body__info">
                    <div class="trip-image">
                        <div class="trip-image__duration">
                            <img src="assets/svg/o-calendar.svg" alt="calendar img">
                            <p>{{ trip.duration }} days</p>
                        </div>
                        <img class="trip-image__img" [src]="extraTripInfo.firstCityImgUrl" alt="city img"
                             role="presentation">
                    </div>
                    <div class="trip-routes">
                        <p>{{ extraTripInfo.allRoutes }}</p>
                    </div>
                    <button class="btn-default" [routerLink]="['/trip-planner', trip.visible_id]">
                        Edit trip
                    </button>
                </div>
                <div class="trip-card__body__destinations">
                    <ul class="destinations-list">
                        @for (route of trip.preview; let idx = $index; let last = $last; track idx) {
                            <li>
                                <div class="destinations-list__item">
                                    <div class="item-info">
                                        <div class="number-box" [style.--pin-color]="PIN_COLORS[idx]">
                                            <span class="number-box__index">{{ idx + 1 }}</span>
                                        </div>
                                        <p class="item-info__location">
                                            <span>{{ getCityName(route.name) }}</span>
                                            <span>{{ extraTripInfo.regions[idx] }}</span>
                                        </p>
                                    </div>
                                    <div class="item-duration">
                                        <p class="item-duration__nights">{{ route.days }}</p>
                                    </div>
                                </div>
                                @if (!last && legs.length && legs[idx]; as leg) {
                                    <div class="item-leg">
                                        <img src="assets/svg/ic-route-w.svg" alt="route" role="presentation">
                                        <span>{{ leg.dist }}</span>
                                        <span class="divider"></span>
                                        <span>{{ leg.time }}</span>
                                    </div>
                                }
                            </li>
                        }
                    </ul>
                </div>
                <div class="trip-card__body__map">
                    <app-preview-map
                            [savedTripView]="true"
                            [showMapControls]="false"
                            [destinationsRoute]="destinationsRoute"
                            (tripLegs)="setParsedTripLegs($event)"
                    ></app-preview-map>
                </div>
            </div>
            <div class="trip-card__footer">
                <button class="btn-default btn-primary" (click)="navigateToTripPlanner(trip, eCityProviders.BOOKING)">
                    Book service
                </button>
                <div class="menu-bar">
                    @for (s of SERVICES; let idx = $index; track idx) {
                        @if (idx < 6) {
                            <div class="menu-divider"></div>
                        }
                        <a class="menu-item" [class.menu-item--equal]="idx < 5" (click)="navigateToTripPlanner(trip, s.provider)">
                            <img class="menu-item__img" [src]="'assets/svg/' + s.icon" [alt]="s.type">
                            <span class="menu-item__text">{{ s.type }}</span>
                        </a>
                    }
                    <div class="menu-item" (click)="navigateToUserWishList()">
                        <img class="menu-item__img" src="assets/svg/ic-hearth.svg" alt="hearth">
                        <span class="menu-item__badge">{{favoritesAmount | async}}</span>
                        <span class="menu-item__text">Favorites</span>
                    </div>
                </div>
            </div>
        </div>
    } @else {
        <div class="mobile-trip-card">
            <div class="mobile-trip-card__top" [style.background-image]="'url(' + extraTripInfo.firstCityImgUrl + ')'">
                @if (duration) {
                    <p class="trip-duration-info">
                        <span>{{ duration }}</span>
                    </p>
                }
            </div>
            <div class="mobile-trip-card__content">
                <h4 class="trip-name">{{ trip.name }}</h4>
                <p class="trip-routes">{{ extraTripInfo.allRoutes }}</p>
            </div>
            <div class="mobile-trip-card__bottom">
                <button class="btn-default btn-blue"
                        (click)="showMobileTripOverview()"
                        [disabled]="isMoreTripInfoLoading"
                >
                    View itinerary
                </button>
                <button [matMenuTriggerFor]="menu" class="btn-default btn-menu">
                    <mat-icon [svgIcon]="eSvgIcons.MENU_DOTS_HOR"></mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="shareTrip.next(trip)">
                        <img class="menu-img" src="assets/svg/ic-export.svg" alt="export">
                        <span>Share</span>
                    </button>
                    <button mat-menu-item (click)="onPrintTripOverviewHandler()">
                        <img class="menu-img" src="assets/svg/ic-print-w.svg" alt="print">
                        <span>Print</span>
                    </button>
                    <button mat-menu-item (click)="remove.next(trip)">
                        <img class="menu-img" src="assets/svg/ic-delete.svg" alt="delete">
                        <span>Delete</span>
                    </button>
                </mat-menu>
            </div>
        </div>
    }
    @if (destinations.length) {
        <app-trip-plan-print
            #printElementRef
            [tripName]="trip.name"
            [tripId]="trip.visible_id"
            [itineraryItems]="destinations"
        ></app-trip-plan-print>
    }
} @else {
    @if (breakpointService.isMobile()) {
        <ngx-skeleton-loader [theme]="{height: '296px', margin: '0 0 24px', borderRadius: 8}"></ngx-skeleton-loader>
    } @else {
        <div #tripCardElRef class="trip-card">
            <ngx-skeleton-loader [theme]="{height: tripCardElRef.clientHeight + 'px', margin: 0}"></ngx-skeleton-loader>
        </div>
    }
}
